<template>
    <div>
        <Header backButton></Header>
        <div class="about">
            <img class="logo" alt="Quest Me logo" src="../assets/logo.png">
            <div class="contenu pt-10 indexUp">
                <p class="text-3xl mb-4 leading-tight">Profil</p>

                <div class="flex">
                    <div class="media mb-4 pb-4 dashed-space">
                        <div class="media-left mr-8">
                            <img
                                class="media-object img-circle"
                                :src="(user.custom_pictures[0]) ? user.custom_pictures[0].attributes.link : user.private_avatar"
                            >
                        </div>
                        <div class="media-body mt-4">
                            <h4
                                class="font-bold text-lg media-heading"
                            >{{ (user.custom_first_name) ? user.custom_first_name : "???" }} {{ (user.custom_last_name) ? user.custom_first_name : "???" }}</h4>
                            <p>aka</p>
                            <p class="font-bold text-lg media-heading">{{ user.private_pseudo}}</p>
                            <p>Sexe: {{ (user.sexe) ? user.sexe : "???" }}</p>

                            <span class="text-xs notification-location"></span>
                        </div>
                        <div class="text-xs notification-time"></div>
                    </div>
                </div>

                <div>
                    <p
                        class="mt-4"
                    >Niveau général : {{ (user.level) ? user.level[0].attributes.name : "???" }}</p>
                    <p
                        class="text-xs mt-4 text-right"
                    >xp : {{ (user.xp != null) ? user.xp : "???" }}/ {{ (user.level) ? user.level[0].attributes.nextStep : "???" }}</p>
                    <div class="progressBar">
                        <div
                            class="progressBarContent"
                            :style="{width: xpPourcent((user.level) ? user.level[0].attributes.nextStep : 1)+'%'}"
                        ></div>
                    </div>
                </div>

                <div class="mt-8 pt-8 dashed-space-top onglets flex justify-center">
                    <div @click="profil = 1" class="onglet" :class="{active : profil == 1}">
                        <i class="fas fa-crown"></i>
                        <p>Profil privé</p>
                    </div>
                    <div @click="profil = 2" class="onglet" :class="{active : profil == 2}">
                        <i class="fas fa-hat-wizard"></i>
                        <p>Profil réel</p>
                    </div>
                </div>

                <div class="contenu2" v-if="profil == 1">
                    <p>
                        <b>Localisation :</b>
                        {{ (user.private_location) ? user.private_location : "???" }}
                    </p>
                    <p>
                        <b>Description :</b>
                        {{ (user.private_description) ? user.private_description : "???" }}
                    </p>
                </div>

                <div class="contenu2" v-if="profil == 2">
                    <p>
                        <b>Localisation :</b>
                        {{ (user.custom_location) ? user.custom_location : "???" }}
                    </p>
                    <p>
                        <b>Description :</b>
                        {{ (user.custom_description) ? user.custom_description : "???"}}
                    </p>
                    <p>
                        <b>Age :</b>
                        {{ (user.custom_birth_date) ? user.custom_birth_date : "???"}}
                    </p>
                </div>
            </div>
        </div>

        <Navigation></Navigation>
    </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Navigation from "@/components/Navigation.vue";

export default {
    name: "profil",
    components: {
        Navigation,
        Header
    },
    data() {
        return {
            profil: 0,
            user: {
                custom_pictures: [],
                xp: 0
            },
            profil: 1,
            error: null
        };
    },
    mounted() {
        this.axios
            .get("/api/users/" + this.$route.params.id)
            .then(response => {
                if (response.status == 200) {
                    if (response.data.data[0]) {
                        this.user =
                            response.data.data[0].attributes[
                                response.data.data[0].attributes["noyou"]
                            ].attributes;
                    } else {
                        this.user = response.data.data.attributes;
                    }
                }
            })
            .catch(errors => {
                this.error = errors.data;
            });
    },
    methods: {
        xpPourcent(xpGoal) {
            let value = (this.user.xp * 100) / xpGoal;
            if (value > 100) return 100;
            else return value;
        }
    }
};
</script>

<style lang="scss" scoped>
.about {
    height: 100%;
    margin-top: 60px;

    .logo {
        position: fixed;
        top: -50px;
        left: -65px;
        width: 80%;
        opacity: 0.3;
    }
    .contenu {
        margin: 0 34px 70px 34px;
        text-align: left;

        .media {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            background-color: rgba(255, 255, 255, 0.2);
            padding: 10px 10px 20px 10px;
            max-height: 180px;
            width: 100%;
        }

        .media-left img {
            height: 100px;
            max-width: 100px;
            width: 100px;
            border-radius: 50%;
        }

        .media-heading {
            margin-top: 0;
            margin-bottom: 5px;
        }
        .media-body {
            width: 80%;
            text-align: center;
        }

        .progressBar {
            width: 100%;
            background-color: rgba(79, 0, 182, 0.5);
            height: 10px;
        }

        .progressBar .progressBarContent {
            background-color: #4600b6;
            height: 100%;
        }

        .onglet {
            width: 40%;
            font-size: 1.3em;
            padding: 2% 5%;
            float: left;
            color: black;
            text-align: center;
        }

        .contenu2 {
            clear: both;
            padding: 2%;
        }

        .active {
            i,
            p {
                color: rgba(79, 0, 182, 0.7);
            }
        }
    }
}
</style>
